import { captureException } from '@sentry/browser';
import { loadRecordHit } from 'js/utils/loadRecordHit';
import {
  ImpressionEntity,
  watchImpressions,
} from 'js/utils/impressions/watchImpressions';

type Experiment = {
  bucket: 'control' | 'quick_evaluation_layout';
  workId: number;
  publishedLetterId: number;
  loggedIn: boolean;
  hasAudio: boolean;
  hasPdf: boolean;
  hasSupplementary: boolean;
};

export function trackQuickEvaluationLayoutExperiment(): void {
  const root = document.getElementById('sap-article-body');
  const data = root?.dataset.sapQuickEvaluationLayoutExperiment;
  if (!root || !data) return;
  const experiment: Experiment = JSON.parse(data);
  if (
    experiment.bucket === 'quick_evaluation_layout' &&
    !root.classList.contains('sap--quick-evaluation-layout')
  )
    return;

  window.cwvAbTestBucket = `publishing_2026_q4_sap_quick_evaluation_layout:${experiment.bucket}`;

  void loadRecordHit()
    .then(async () => {
      if (!window.Aedu?.hit_data?.id) return;
      if (document.hidden) {
        await new Promise<void>((resolve) => {
          const onVisible = () => {
            if (document.hidden) return;
            document.removeEventListener('visibilitychange', onVisible);
            resolve();
          };
          document.addEventListener('visibilitychange', onVisible);
        });
      }
      const extra = {
        bucket: experiment.bucket,
        published_letter_id: experiment.publishedLetterId,
        logged_in: experiment.loggedIn,
        has_audio: experiment.hasAudio,
        has_pdf: experiment.hasPdf,
        has_supplementary: experiment.hasSupplementary,
        figure_count: root.querySelectorAll('.sap__fig').length,
        table_count: root.querySelectorAll('.sap__table-wrap:has(table)')
          .length,
        viewport: window.innerWidth < 1280 ? 'small' : 'large',
      };
      const article = root.querySelector<HTMLElement>('#article-root');
      if (!article) return;
      watchImpressions(article, {
        source: 'sap_quick_evaluation_layout_experiment',
        entity_id: experiment.workId,
        entity_type: ImpressionEntity.Work,
        threshold: 0,
        noBatch: true,
        extra,
      });
    })
    .catch(captureException);
}
